import React, { useEffect, useRef, useState, lazy, Suspense } from 'react'
import './index.scss'
import DriverCard from '@/components/drivercard'
import MemberCard from '@/components/membercard'
// import FleetLeaderInvite from '@/components/fleetleaderinvite'
import NoMember from '@/components/nomember'
import Bs from '@better-scroll/core'
// import DelMember from '@/components/delmember'
import PullUp from '@better-scroll/pull-up';
import { connect } from 'react-redux'
import useDeepCompareEffect from 'use-deep-compare-effect'
import FleetAward  from './fleetaward/index'
import fleetBg from '@/assets/images/fleetbg.png'

// 成员信息action
import { fleetdriverinfoAction } from '@/store/actions/fleetdriverinfoAction'
// 车队分页
import { fleetpageAction } from '@/store/actions/fleetpageAction'
// 车队链接
import { fleetinviteAction } from '@/store/actions/fleetinviteAction'
// 邀请弹窗
const FleetLeaderInvite = lazy(() => import('@/components/fleetleaderinvite'))
// 删除弹窗
const DelMember = lazy(() => import('@/components/delmember'))


const fleetBgStyle = {
    backgroundImage :`url(${fleetBg})`,
    backgroundRepeat : 'no-repeat',
    backgroundSize : '100% 50%',
    backgroundAttachment:'fixed'
}
const mapStateToProps = (state) => ({
    //接单
    driverAcceptOrder: state.getIn(['fleetdriverinfoReducer', 'driverAcceptOrder']),
    //取消单子
    driverCancelOrder: state.getIn(['fleetdriverinfoReducer', 'driverCancelOrder']),
    //司机名字
    driverName: state.getIn(['fleetdriverinfoReducer', 'driverName']),
    //在线时长
    onlineTime: state.getIn(['fleetdriverinfoReducer', 'onlineTime']),
    //四否为队长
    isCaptain: state.getIn(['fleetdriverinfoReducer', 'isCaptain']),
    //流水
    payableAmount: state.getIn(['fleetdriverinfoReducer', 'payableAmount']),
    // 奖励金额
    rewardAmount : state.getIn(['fleetdriverinfoReducer', 'rewardAmount']),
    // 是否在线
    status: state.getIn(['fleetdriverinfoReducer', 'status']),
    //分页
    fleetList: state.getIn(['fleetpageReducer', 'fleetList']),
    // 分页总数
    total: state.getIn(['fleetpageReducer', 'total']),
    //页数
    pageNum: state.getIn(['fleetpageReducer', 'pageNum']),
    // 邀请链接
    fleetinviteLink: state.getIn(['fleetinviteReducer', 'fleetinvitelink'])
})
const mapDispatchToProps = (dispatch) => ({
    // 获取车队司机信息
    handleGetFleetDriverInfo() {
        return dispatch(fleetdriverinfoAction())
    },
    // 车队信息分页
    handleGetFleetPage(params) {
        return dispatch(fleetpageAction(params))
    },
    // 获取邀请链接
    handleGetFleetinviteLink() {
        return dispatch(fleetinviteAction());
    }

})
Bs.use(PullUp);
const FleetLeader = (props) => {
    // 获取props中的方法、数据
    let { total, pageNum, fleetList, handleGetFleetPage, handleGetFleetDriverInfo, driverAcceptOrder, driverCancelOrder, driverName, onlineTime, isCaptain, payableAmount, status, handleGetFleetinviteLink, fleetinviteLink ,rewardAmount} = props
    // 删除司机的id,名字 和电话
    let [delDriverId, setDelDriverId] = useState();
    let [delDriverPhone, setDelDriverPhone] = useState();
    let [delDriverName, seDelDriverName] = useState('');
    // 总数
    let [stateTotal, setStateTotal] = useState(0)
    // 上拉加载文本
    let [more, setMore] = useState('查看更多...')
    // 分页数组
    let [mypageArr, setMypageArr] = useState([]);
    // 分页数
    let [mypageNum, setMypageNum] = useState(1);
    // better-scroll
    let [BScroll, setBScroll] = useState();
    // 滚动dom
    let wrapper = useRef();
    // 控制分享弹窗
    let [shareMState, setShareMState] = useState(false);
    // 分页列表项目的index
    let [membercardId,setmembercardId] = useState({delIndex:0});
    // 移除对应的列表项目
    const handleRemoveMember = () => {
        if( membercardId.delIndex >= 0 ){
            let newArr = mypageArr.filter( (item,index) => index !== membercardId.delIndex );
            setMypageArr( newArr );
            setStateTotal( stateTotal - 1 );
            if( BScroll ){
                BScroll.refresh();
            }
        }
    }
    const handleShowShareModal = () => {
        if (!shareMState) {
            // 车队邀请链接
            handleGetFleetinviteLink();
        }
        setShareMState(!shareMState);
    }
    //是否显示删除member弹窗
    let [isShowDel, setIsShowDel] = useState(false);
    //控制隐藏isShowDel
    const handleIshowDel = (driverId, driverPhone, driverName) => {
        //拿到membercard组件中要移除的id name phone
        setDelDriverId(driverId);
        setDelDriverPhone(driverPhone)
        seDelDriverName(driverName)
        setIsShowDel(!isShowDel);
    }

    // membercard dom
    // let cRef = useRef()
    // useEffect(() => {
        // // 分页页数
        // var pageCount = 1
        // // 队长信息
        // handleGetFleetDriverInfo();
        // // better-scroll
        // const bscroll = new Bs(wrapper.current, {
        //     scrollY: true,
        //     scrollX: false,
        //     click: true,
        //     probeType: 3,
        //     bounce: {
        //         top: false,
        //     },
        //     deceleration: 0.001,
        //     pullUpLoad: {
        //         threshold: -150 // 当上拉距离超过50px时触发 pullingUp 事件
        //     }

        // })
        // // 分页信息
        // handleGetFleetPage({
        //     pageNo: 1,
        //     pageSize: 6
        // })
        //     .then(() => {
        //         console.log(fleetList)
        //         setStateTotal(total)
        //         bscroll.refresh();
        //     })
        // async function handlepullingUp() {
        //     pageCount += 1
        //     // 上啦加载
        //     await handleGetFleetPage({
        //         pageNo: 1,
        //         pageSize: pageCount * 6
        //     })
        //     await bscroll.finishPullUp()
        //     await bscroll.refresh();
        // }
        // bscroll.on('pullingUp', handlepullingUp)

        // if (fleetList.length >= stateTotal || fleetList.size >= stateTotal && stateTotal > 0) {
        //     console.log(stateTotal,'wangshuai')
        //     setMore('没有更多数据')
        //     bscroll.off('pullingUp', handlepullingUp)
        // }

        // return () => {
        // }

    // }, [])


    // 获取队长数据\分页数据
    useEffect(() => {
        handleGetFleetDriverInfo();
        handleGetFleetPage({
            pageNo: 1,
            pageSize: 10
        })
    }, [handleGetFleetDriverInfo,handleGetFleetPage])

    useDeepCompareEffect(() => {
        // 分页赋值
        setMypageArr(() => {
            let newArr = [...mypageArr, ...fleetList]
            return newArr
        });
        // 总数
        setStateTotal(total)
    }, [fleetList, total])
    useEffect(() => {
        // better-scroll
        const bscroll = new Bs(wrapper.current, {
            scrollY: true,
            scrollX: false,
            click: true,
            probeType: 3,
            bounce: {
                top: false,
            },
            deceleration: 0.001,
            pullUpLoad: {
                threshold: -100 // 当上拉距离超过50px时触发 pullingUp 事件
            }
        })
        setBScroll(bscroll)
        return () => {
            setBScroll(null);
        }
    }, [])
    // better-scroll重新计算
    useEffect(() => {
        if (!BScroll) return
        BScroll.refresh();
    },[mypageArr])
    // 分页
   
    useEffect(() => {
        if (!BScroll) return
        function handlepullingUp() {
            setMypageNum( mypageNum += 1 );
            // 上啦加载
            handleGetFleetPage({
                pageNo: mypageNum,
                pageSize: 10
            }).then( () => {
                BScroll.finishPullUp()
            } ) 
            BScroll.refresh();
        }
        BScroll.on('pullingUp', handlepullingUp)
        
    }, [BScroll])
    useEffect( () => {
        if(!BScroll) return
        if( mypageNum * 10 >= stateTotal && stateTotal > 0 ){
            setMore('数据加载完毕')
        }
    } ,[mypageArr,stateTotal,pageNum,BScroll,mypageNum])
    // membercard实例dom
    let cRef = useRef()
    // 滚动移除所有popover
    useEffect(() => {
        if(!BScroll) return
        BScroll.on('scrollStart',() => {
            let popoverList = document.querySelectorAll('.more_popover');
            if(popoverList.length > 0){
                for( let i = 0 , k = popoverList.length ; i < k ;i++ ){
                    popoverList[i].style.display = 'none';
                }
            }
            if(cRef.current){
                cRef.current.handleSetIsShowPopover();
            }
        })
    }, [BScroll])
    return (
        <div className="fleet-leader__box" style={fleetBgStyle}>
            <div className='fleet-leader__show' ref={wrapper}>
                <div className="fleet-leader_scroll" >
                    
                    <div className="fleet-leader-info__box">
                        {/* 是否为车队队长 */}
                        <DriverCard
                            isLeader={isCaptain}
                            driverAcceptOrder={driverAcceptOrder}
                            driverCancelOrder={driverCancelOrder}
                            driverName={driverName}
                            onlineTime={onlineTime}
                            payableAmount={payableAmount}
                            rewardAmount={rewardAmount}
                            status={status}
                        />
                    </div>
                    {/* 车队奖励 */}
                    <FleetAward BScroll={BScroll} />
                    <div className="fleet-team-info__box">
                        {mypageArr.map((item, key) => (
                            <MemberCard
                                driverAcceptOrder={item.driverAcceptOrder}
                                driverId={item.driverId}
                                driverName={item.driverName}
                                driverStatus={item.driverStatus}
                                fleetId={item.fleetId}
                                onlineTime={item.onlineTime}
                                rewardAmount={item.payableAmount}
                                driverPhone={item.driverPhone}
                                handleIshowDel={handleIshowDel} 
                                ref={cRef} 
                                
                                index={key} setmembercardId={setmembercardId} key={Math.random()} />
                        ))}
                        {/* 没有数据提示 */}
                        {
                            mypageArr.length <= 0 || mypageArr.size <= 0 ? <NoMember /> : ''
                        }
                    </div>
                    {
                        mypageArr.length >= 6 || mypageArr.size >= 6 ? <p className="more">{more}</p> : ''
                    }

                </div>
            </div>
            <footer>
                <button onClick={handleShowShareModal} style={(React.colorConfig ? React.colorConfig.buttonBg : {})}>邀请新司机</button>
            </footer>
            <Suspense fallback={''}>
                <FleetLeaderInvite fleetinviteLink={fleetinviteLink} shareMState={shareMState} handleShowShareModal={handleShowShareModal} />
            </Suspense>

            {isShowDel ?
                <Suspense fallback={''}>
                    <DelMember delDriverId={delDriverId} delDriverPhone={delDriverPhone} delDriverName={delDriverName} handleIshowDel={handleIshowDel} handleRemoveMember={handleRemoveMember} handleGetFleetPage={handleGetFleetPage} />
                </Suspense>
                : ''}
        </div>
    )
}
export default connect(mapStateToProps, mapDispatchToProps)(FleetLeader)
